import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';

@Component({
  selector: 'skc-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.less']
})
export class SvgComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-image-src') imageSrc;
  @Input('skc-image-color') imageColor;
  @Input('skc-height') height;
  @Input('skc-width') width;
  imageSrcStyle;
  constructor() {
    super();
  }

  ngOnInit() {
    this.initProperties();
  }

  backgroundImageStyle(url) {
    return {
      '-webkit-mask': 'url(' + url + ')',
      mask: 'url(' + url + ')'
    };
  }

  private initProperties() {
    if (!this.width) {
      this.width = '20em';
    }
    if (!this.height) {
      this.height = '20em';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.imageSrc) {
      this.imageSrcStyle = this.backgroundImageStyle(this.imageSrc);
    }
  }
}
